import Vue from "vue";
import VueRouter from "vue-router";
import defaultLayout from "../layouts/defaultLayout.vue";
import authLayout from "../layouts/authLayout.vue";
import { Auth } from "@/store/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: defaultLayout,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home.vue"),
      },
      {
        path: "/countries",
        name: "countries",
        component: () => import("@/views/countries/index.vue"),
      },
      {
        path: "/support",
        name: "support",
        component: () => import("@/views/support/index.vue"),
      },
      {
        path: "/more/categories",
        name: "categories",
        component: () => import("@/views/categories/index.vue"),
      },
      {
        path: "/more/cards",
        name: "cards",
        component: () => import("@/views/cards/index.vue"),
      },
      {
        path: "/card/:id",
        name: "card",
        component: () => import("@/views/cards/showCard"),
      },
      {
        path: "/more/cities",
        name: "cities",
        component: () => import("@/views/cities/index.vue"),
      },
      {
        path: "/more/users",
        name: "users",
        component: () => import("@/views/users/index.vue"),
      },
      {
        path: "/user/:id",
        name: "user",
        component: () => import("@/views/users/showUser"),
      },
      {
        path: "/insurance",
        name: "insurance",
        component: () => import("@/views/insurances/index"),
      },
    ],
  },
  {
    path: "/",
    component: authLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/login.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name != "login") {
    if (!localStorage.getItem("token") || !Auth.token) {
      next("/login");
    }
  }

  next();
});

export default router;
